/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="13.46"
        height="19"
        viewBox="0 0 13.46 19"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M0 6.74c0 6.74 6.16 11.8 6.43 12l.31.25.31-.25c.27-.21 6.4-5.26 6.4-11.94A6.65 6.65 0 0 0 6.71-.01a6.5 6.5 0 0 0-4.93 2.06A6.81 6.81 0 0 0 0 6.73ZM6.71 1a5.67 5.67 0 0 1 5.75 5.82c0 5.37-4.56 9.83-5.72 10.88C5.57 16.65.97 12.19 1 6.7a5.87 5.87 0 0 1 1.51-4A5.53 5.53 0 0 1 6.71 1Zm0 9.12a3.14 3.14 0 1 0-3.14-3.14 3.13 3.13 0 0 0 3.14 3.14Zm0-5.27a2.14 2.14 0 1 1-2.14 2.13 2.13 2.13 0 0 1 2.18-2.13Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'MapPinIcon';

export default Icon;
